/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown> }} Files_Selection_LimitInputs */

const en_files_selection_limit = /** @type {(inputs: Files_Selection_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can add up to ${i?.limit} files at a time.`)
};

const es_files_selection_limit = /** @type {(inputs: Files_Selection_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puedes agregar hasta ${i?.limit} archivos a la vez.`)
};

/**
* | output |
* | --- |
* | "You can add up to {limit} files at a time." |
*
* @param {Files_Selection_LimitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_selection_limit = /** @type {((inputs: Files_Selection_LimitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Selection_LimitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_selection_limit(inputs)
	return en_files_selection_limit(inputs)
});